"use strict";

import $ from "jquery";

(function () {
  /**
   * Wait for CMP to be ready (TCF or GPP)
   * @returns {Promise<boolean>} Promise that resolves to true when CMP is ready, false if no CMP found
   */
  const waitForCMPReady = () => {
    return new Promise((resolve) => {
      // Check GPP first (US and other regions without GDPR dialog)
      if (typeof window.__gpp === 'function') {
        window.__gpp('ping', (pingData) => {
          if (pingData && (pingData.cmpStatus === 'loaded' || pingData.signalStatus === 'ready')) {
            // Check if TCF is also present (GDPR dialog shown)
            if (typeof window.__tcfapi === 'function') {
              // Both GPP and TCF present - defer to TCF consent check
              checkTCFConsent(resolve);
            } else {
              // GPP only - allow Taboola
              resolve(true);
            }
          }
        });
        return;
      }

      // Check TCF for GDPR regions or regions with GDPR dialog
      if (typeof window.__tcfapi === 'function') {
        checkTCFConsent(resolve);
        return;
      }

      // No CMP found - don't load Taboola
      resolve(false);
    });
  };

  const checkTCFConsent = (resolve) => {
    // First try to get current data immediately
    window.__tcfapi('getTCData', 2, function(tcData, success) {
      if (success && tcData) {
        // Check consent for Purpose 3 (ad profiles) or 4 (ad selection)
        const consentGranted = tcData.purpose && tcData.purpose.consents &&
                             (tcData.purpose.consents[3] || tcData.purpose.consents[4]);
        resolve(consentGranted);
      } else {
        // Fall back to addEventListener if getTCData fails
        window.__tcfapi('addEventListener', 2, function(tcData, success) {
          if (success && tcData && (tcData.eventStatus === 'tcloaded' || tcData.eventStatus === 'useractioncomplete')) {
            const consentGranted = tcData.purpose && tcData.purpose.consents &&
                                 (tcData.purpose.consents[3] || tcData.purpose.consents[4]);
            resolve(consentGranted);
          }
        });
      }
    });
  };

  const loadTaboolaScript = () => {
    window._taboola = window._taboola || [];
    _taboola.push({article:'auto'});

    if (!document.getElementById('tb_loader_script')) {
      const script = document.createElement('script');
      script.async = true;
      script.src = '//cdn.taboola.com/libtrc/myanimelist/loader.js';
      script.id = 'tb_loader_script';
      document.head.appendChild(script);
    }

    if (window.performance && typeof window.performance.mark == 'function') {
      window.performance.mark('tbl_ic');
    }
  };

  // Wait for CMP to be ready using event-driven approach
  const waitForCMPAndLoadTaboola = () => {
    let cmpReady = false;

    const loadTaboola = () => {
      if (cmpReady) return; // Prevent double execution
      cmpReady = true;

      waitForCMPReady().then((allowTaboola) => {
        if (allowTaboola) {
          loadTaboolaScript();
        }
      });
    };

    // Listen for GPP events
    if (typeof window.__gpp === 'function') {
      window.__gpp('addEventListener', (event) => {
        if (event && (event.eventName === 'signalStatus' || event.eventName === 'sectionChange')) {
          // Check if GPP is ready
          window.__gpp('ping', (pingData) => {
            if (pingData && pingData.cmpStatus === 'loaded' && pingData.signalStatus === 'ready') {
              loadTaboola();
            }
          });
        }
      });

      // Also check immediately in case it's already ready
      window.__gpp('ping', (pingData) => {
        if (pingData && pingData.cmpStatus === 'loaded' && pingData.signalStatus === 'ready') {
          loadTaboola();
        }
      });
    }

    // Listen for TCF events
    if (typeof window.__tcfapi === 'function') {
      window.__tcfapi('addEventListener', 2, (tcData, success) => {
        if (success && tcData && (tcData.eventStatus === 'tcloaded' || tcData.eventStatus === 'useractioncomplete')) {
          loadTaboola();
        }
      });
    }

    // Fallback timeout in case events don't fire
    setTimeout(() => {
      if (!cmpReady) {
        if (typeof window.__gpp === 'function' || typeof window.__tcfapi === 'function') {
          loadTaboola();
        }
      }
    }, 10000); // 10 second fallback
  };

  const execute = () => {
    // Only execute on anime/manga/character pages
    const currentPath = window.location.pathname;
    if (!/^\/(anime|manga|character)\/\d+/.test(currentPath)) {
      return;
    }

    waitForCMPAndLoadTaboola();
  };

  execute();
})();